import { Component, type ReactNode } from "react";
export class ErrorBoundary extends Component<
  { children: ReactNode },
  { failed: boolean }
> {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  render() {
    if (this.state.failed)
      return (
        <main className="error-screen">
          <h1>PULSE needs a fresh start.</h1>
          <p>
            Your saved experiment will be retained. Reload to restore the city.
          </p>
          <button className="primary-button" onClick={() => location.reload()}>
            Reload PULSE
          </button>
        </main>
      );
    return this.props.children;
  }
}
